import {
  EDUCATION_LOADING,
  GET_EDUCATION,
  GET_EDUCATION_SUCCESS,
  GET_EDUCATION_FAIL,
  ADD_EDUCATION_SUCCESS,
  ADD_EDUCATION_FAIL,
  DELETE_EDUCATION_SUCCESS,
  DELETE_EDUCATION_FAIL,
  UPDATE_EDUCATION_SUCCESS,
  UPDATE_EDUCATION_FAIL,
  EDUCATION_RESET
} from "./actionType";

const INIT_STATE = {
  educations: [],
  error: {},
};

const Education = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_EDUCATION_SUCCESS:
      switch (action.payload.actionType) {
        case GET_EDUCATION:
          return {
            ...state,
            educations: action.payload.data,
            isEducationCreated: false,
            isEducationSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_EDUCATION_FAIL:
      switch (action.payload.actionType) {
        case GET_EDUCATION_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isEducationCreated: false,
            isEducationSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_EDUCATION: {
      return {
        ...state,
        isEducationCreated: false,
        loading: true,
      };
    }

    case EDUCATION_LOADING: {
      return {
        ...state,
        isEducationCreated: false,
        loading: true,
      };
    }

    case ADD_EDUCATION_SUCCESS:
      return {
        ...state,
        isEducationCreated: true,
        loading: false,
        educations: [action.payload.data, ...state.educations],
      };

    case ADD_EDUCATION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_EDUCATION_SUCCESS:
      return {
        ...state,
        loading: false,
        educations: state.educations.filter(
          education => education.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_EDUCATION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_EDUCATION_SUCCESS:
      return {
        ...state,
        loading: false,
        educations: state.educations.map(education =>
          education.id.toString() === action.payload.data.id.toString() ? { ...education, ...action.payload.data } : education
        ),
      };

    case UPDATE_EDUCATION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case EDUCATION_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default Education;